import React from 'react';
import classNames, { Argument } from 'classnames';

import useCurrentStep from 'hooks/useCurrentStep';

import Icon from '../Icon';
import HelpModal from './Modal';
import { useIntl } from 'react-intl';
import Button, { ButtonType } from '../Button';

const HelpButton: React.FC<{ className?: Argument }> = ({ className }) => {
  const intl = useIntl();
  const [isOpen, setIsOpen] = React.useState(false);
  const currentStep = useCurrentStep();

  const handleOpenModal = () => setIsOpen(true);
  const handleCloseModal = () => setIsOpen(false);

  return (
    <div className="py-3 kiosk:py-10 z-50">
      <Button
        className={classNames('size-10 kiosk:size-20 !p-2 flex items-center justify-center btn-header', className)}
        aria-label={intl.formatMessage({ id: 'helpLine.title', defaultMessage: 'Need help ?' })}
        onClick={handleOpenModal}
        type={ButtonType.SECONDARY}
        testId="help-button"
        analytics={{
          category: 'Help',
          action: 'Help button',
          label: `Help needed from ${currentStep}`,
        }}
      >
        <Icon className="fb-icon--question text-2xl kiosk:text-4xl" />
      </Button>
      <HelpModal open={isOpen} onClose={handleCloseModal} />
    </div>
  );
};

export default HelpButton;
